const API_BASE_ADDRESS = 'http://localhost:4000';

export default class Api {
    static getInboundData() {
        const uri = API_BASE_ADDRESS + "/inboundData";

        return fetch(uri, {
            method: 'GET'
        });
    }
}